import '../../App.css';
import './index.css';

const QuemSomos = () => {
    return (
        <div>
            <div className="py-5">
                <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="sub-style">
                        <h4 className="sub-title px-3 mb-0">Quem Somos</h4>
                    </div>
                </div>
                <div className='row text-center quemSomos'>
                    <div className='row px-0 fundoLinhaEscura'>
                        <div className='col-xl-1'></div>
                        <div className='col-12 col-xl-4'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='simbolico'>ACOLHIMENTO</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>ANFITRIÕES DE JESUS</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 px-0'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>TÉCNICAS DA ASSEPSIA</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>PERFUMISTAS DO NOSSO CAMINHO</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-1'></div>
                    </div>
                    <div className='row px-0 fundoLinhaClara'>
                        <div className='col-xl-1'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>TI</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>ARTISTAS DIGITAIS</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 px-0'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>MARKETING</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>ESPELHO DA VERDADE</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-1'></div>
                    </div>
                    <div className='row px-0 fundoLinhaEscura'>
                        <div className='col-xl-1'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>COLABORADORES</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>TRABALHADORES DA EMPATIA</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 px-0'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>FARMACÊUTICAS E BIOMÉDICAS</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>ALQUIMISTAS DA BONDADE</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-1'></div>
                    </div>
                    <div className='row px-0 fundoLinhaClara'>
                        <div className='col-xl-1'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>TÉCNICAS DE ENFERMAGEM</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>ESTRELAS DIVINAS DA ROTINA</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 px-0'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>ENFERMEIRAS</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>ANJOS DE DEVOÇÃO E AMOR</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-1'></div>
                    </div>
                    <div className='row px-0 fundoLinhaEscura'>
                        <div className='col-xl-1'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>FISIOTERAPEUTAS</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>MALABARISTAS ABENÇOADAS DE DEUS</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-2 px-0'></div>
                        <div className='col-12 col-xl-4 coluna'>
                            <div className='row'>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p>MÉDICOS</p>
                                </div>
                                <div className='col-2 col-xl-4 coluna'>
                                    <i className="bi bi-arrow-left-right iconSeta" />
                                </div>
                                <div className='col-5 col-xl-4 coluna'>
                                    <p className='strong'>MAESTROS</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-1'></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default QuemSomos;